import { Avatar, AvatarGroup, Divider } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { HorizontalStack, SmartContainer, Stack } from '../../../styles/Containers';
import { StyledIconButton } from '../../../styles/matieralui/IconButton';
import { StyledB, StyledP } from '../../../styles/StyledHTML';
import { IconAdd, IconShare } from '../../Icons';
import { StyledModal } from '../../../styles/matieralui/Modal';
import { PermissionsManager, usePermissionsManager } from './PermissionsManager';
import { StyledButton } from '../../../styles/matieralui/Button';
import styled, { css } from 'styled-components';
import { ProfilePicture } from '../../../components/User/ProfilePicture';

const StyledAvatarGroup = styled(AvatarGroup)`
    .MuiAvatar-root{
        width: 24px;
        height: 24px;
        font-size: 0.75rem;
    }
    cursor: pointer;
`

export const PermissionsEditor = ({ model, modelId, selector, action }) => {

    const dispatch = useDispatch();
    const store = selector();
    const [open, setOpen] = useState(false);
    const { storePermissions, activeMembers, inactiveMembers } = usePermissionsManager({ model, modelId, selector, action });


    const renderPermissionsPreview = () => {
        if (!store?.items) return null;
        if (store?.itemsLoading) return (<StyledP light small>Loading...</StyledP>)
        if (store?.items?.count <= 0) return (<StyledP light small>No additional access has been granted</StyledP>)
        return store?.items?.rows?.map(p => {
            return (
                <StyledP>{p.UserId} - {p.RoleId} - User and Role</StyledP>
            )
        })
    }

    const renderAvatarGroups = () => {
        if (!activeMembers) return null;
        return (
            <HorizontalStack flex align="center" clickable onClick={() => setOpen(true)}>
                <StyledP light small>Sharing</StyledP>
                <StyledAvatarGroup max={4} onClick={() => setOpen(true)}>
                    {activeMembers.map(u => (<ProfilePicture key={u?.id} user={u} />))}
                </StyledAvatarGroup>
            </HorizontalStack>
        )
    }

    return (
        <HorizontalStack>
            {renderAvatarGroups()}

            {/* <StyledButton variant='outlined' onClick={() => setOpen(true)}><IconShare />Share</StyledButton> */}
            {/* <SmartContainer flex justify="space-between" align="center">
                <StyledP><StyledB>Permissions</StyledB></StyledP>
                <StyledIconButton onClick={() => setOpen(true)}>
                    <IconAdd />
                </StyledIconButton>
            </SmartContainer>
            <StyledP light small>All Owners and Admins have access by default</StyledP>
            <Divider />

            {renderPermissionsPreview()} */}

            <StyledModal open={open} onClose={() => setOpen(false)} label="Permissions">
                <PermissionsManager model={model} modelId={modelId} selector={selector} action={action} />
            </StyledModal>

        </HorizontalStack>
    )
}